import { useContext } from "react";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup, faBadgeCheck } from "@fortawesome/pro-duotone-svg-icons";
import { faPlusCircle, faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

import { isObjectNotEmpty, parseBoolOr, parseStringOr } from "../../helpers/AppxUtils";
import { TvPlanContext } from "../../contexts/tvplancontext";
import Price from "../Price";

import "./index.css";


export default function TvChannelTile(props) {
    const ctx = useContext(TvPlanContext);
    const cfg = ctx.getTvConfig();
    const code = props.code;
    const serviceCode = props.serviceCode || code;
    const chr = cfg.channels[code] || {};
    const isMultiplex = parseBoolOr(props.isMultiplex, false);
    let tileIcon = "";

    if (isObjectNotEmpty(chr)) {
        tileIcon = parseStringOr(chr?.tileIcon, "");
    }

    let logoCode = code;

    if (tileIcon !== "") {
        logoCode = (<img src={`${process.env.PUBLIC_URL}/chicons/${tileIcon}`} alt="logo" />);
    }

    let tooltip = chr?.des || chr?.label || code;
    let tileClass = "tv-channel-tile";
    let containerClass = "tv-channel-tile-container";
    let hasPlusCode = null;

    if (props.hasPlus) {
        hasPlusCode = (
            <div className="tv-channel-tile-plus">
                <FontAwesomeIcon icon={faPlusCircle} />
            </div>
        );
    }

    if (props.size === "large") {
        tileClass += " large";
        containerClass += " large";
    }

    let svc = cfg.service[serviceCode] || {};

    if (!isObjectNotEmpty(svc)) {
        return (
            <div className={containerClass}>
                <div className={tileClass}>
                    <Tooltip placement="top" title={tooltip}>
                    <div className="tv-channel-tile-logo">
                     {logoCode}
                    </div>
                    </Tooltip>
                </div>
                {hasPlusCode}
            </div>
        );
    }

    let isStandalone = false;
    let isPick = false;
    let myPriceChoice = props?.myPriceChoice || null;

    if (myPriceChoice == null) {
        if (props.pickMode !== 'FIXED') {
            myPriceChoice = ctx.getPriceChoice(serviceCode);
        }
    }

    if (myPriceChoice === "standalone") {
        isStandalone = true;
    }

    if (myPriceChoice === "pick") {
        isPick = true;
    }

    let label = chr.label || "";
    let prices = svc.price || {};
    let pickPrice = parseFloat(prices?.pick) || 0;
    let saPrice = parseFloat(prices?.standalone) || 0;
    let rights = svc.rights || {};
    let minPickServices = rights.minPickServices || -1;
    // let canPick = false;

    // if (pickPrice > 0) {
    //     canPick = true;
    // }
    let labelCode = null;
    let codeLabel = null;
    let saCode = null;

    if (label.length > 0) {
        labelCode = (<div className="tv-channel-tile-label">{label}</div>);
    }

    if (code && code.length > 0) {
        codeLabel = (<div className="tv-channel-tile-code">{code}</div>);
    }

    if (isMultiplex) {
        saPrice = 0;
        pickPrice = 0;
    }

    const showPrice = parseBoolOr(props?.showPrice, true);

    if (showPrice && props.size === "large" && saPrice > 0) {
        let saClass = 'tv-channel-tile-sa-price';

        if (isStandalone) {
            saClass += " standalone ";
        }

        if (isPick) {
            saClass += " pick ";
        }

        if (props.pickMode === "FIXED") {
            saClass += " tv-channel-tile-fixed ";
        }

        saCode = (<div className={saClass}><Price>{saPrice}</Price></div>);
    }

    let pickCode = null;
    let groupCount = null;

    if (props.pickMode !== "FIXED" && props.size === "large" && pickPrice > 0) {
        pickCode = (
            <div className="tv-channel-tile-pick-price">
                <Price>{pickPrice}</Price>
            </div>
        );
        groupCount = (
            <div className="tv-channel-tile-pick-group-count">
                <div className="stack-bg" />
                <div className='tv-channel-tile-stack-icon'>
                    <FontAwesomeIcon icon={faLayerGroup} />
                </div>
                <div className="tv-channel-pick-group-count-val">
                    {minPickServices}<span className="tv-channel-pick-group-count-plus">+</span>
                </div>
            </div>
        );
    }

    const showSelected = parseBoolOr(props.showSelected, true);
    let checkCode = null;

    if (showSelected) {
        const implicit = parseBoolOr(props.implicit, false);
        const groupCode = parseStringOr(props?.groupCode, "");

        if (implicit && groupCode === "") {
            tileClass += " implicit ";
            checkCode = (
                <div className="tv-channel-tile-imp-check">
                    <FontAwesomeIcon icon={faBadgeCheck} />
                </div>
            );
        }
        else {
            const selected = parseBoolOr(props.selected, false);

            if (selected) {
                let checkClass = "tv-channel-tile-check";

                if (isStandalone) {
                    tileClass += " selectedsa";
                    checkClass += " selectedsa";
                }
                else {
                    tileClass += " selected";
                }

                checkCode = (
                    <div className={checkClass}>
                        <FontAwesomeIcon icon={faCheckCircle} />
                    </div>
                );
            }
        }
    }

    if (props.pickMode === "FIXED") {
        tileClass += " tv-channel-tile-fixed";
    }

    return (
        <div className={containerClass} data-apiCode={code}>
            <div className={tileClass}>
                {codeLabel}
                <Tooltip placement="top" title={tooltip}>
                    <div className="tv-channel-tile-logo">
                        {logoCode}
                        {labelCode}
                    </div>
                </Tooltip>
                {pickCode}
                {groupCount}
                {saCode}
            </div>
            {hasPlusCode}
            {checkCode}
        </div>
    );
}
